module.exports = __webpack_public_path__ + "img/logo.b9649ef9.svg";